import { InstituteDetails, User } from '@admin/api/apiTypes';
import React from 'react';
import UntypedPassportTable from './PassportTable';

export type PassportTableFilters = Record<string, unknown>;

interface PassportTableProps {
  institute?: InstituteDetails | null;
  title: string;
  filters: PassportTableFilters | null;
  showExportButton: boolean;
  // Rendered in the table's header, beside the title and row count.
  filterChips?: React.ReactNode;
}

// PassportTable is untyped JS wrapped in withStyles, so its inferred props
// still require `classes`, which the HOC injects.
export const PassportTable = UntypedPassportTable as React.ComponentType<PassportTableProps>;

// Non-admins only see the people they supervise, on top of any filters supplied
// by the caller.
export const supervisorScopedFilters = (
  filters: PassportTableFilters | null,
  user: User | null
): PassportTableFilters | null => {
  if (!user) {
    return filters;
  }

  if (user.is_supervisor) {
    return { ...filters, supervisor_id_eq: user.id };
  }

  return filters;
};
